import {
  SET_AREAS_SAP,
  SET_PROVINCES_SAP,
  SET_CITIES_SAP,
  SET_DISTRICTS_SAP,
  SET_VILLAGES_SAP,
  SET_BRANCHES_SAP,
  SET_BRANCHES_BY_ID_SAP,
  SET_BRANCHES_BY_AREAID_SAP,
  JENIS_AXI,
  SET_RELIGIONS,
  SET_STATUS,
  SET_GENDERS,
  SET_LEGAL_FORM,
  SET_AREAS_SAP_BY_ID,
  SET_PROVINCES_SAP_BY_ID,
  SET_CITIES_SAP_BY_ID,
  SET_DISTRICTS_SAP_BY_ID,
  SET_PROFILE_ID,
  SET_RESULT_REVISI,
  SET_THIRD_PARTY_SETTING,
  SET_THIRD_PARTY_PAGE_SETTING,
  SET_BRANCH_BY_POSTALCODE_SAP,
  JENIS_KARYAWAN,
} from "@/stores/constants";
import {
  getAreasSap,
  getProvincesSap,
  getCitiesSap,
  getDistrictsSap,
  getVillagesSap,
  // getBranchesSap,
  getBranchesByIdSap,
  getBranchesByAreaIdSap,
  getJenisAXI,
  getReligions,
  getStatus,
  getGenders,
  getLegalForm,
  getAreasSapById,
  getProvincesSapById,
  getCitiesSapById,
  getDistrictsSapById,
  patchUpdateRevisi,
  getDecryptProfileId,
  getThirdPartySetting,
  postThirdPartyValue,
  getThirdPartyPageSetting,
  getCheckEmail,
  getCheckNoKtp,
  getCheckNoHp,
  getBranchByPostalCode,
  getJenisKaryawan,
} from "@/services/sap";

export default {
  namespaced: true,
  state: {
    areas: [],
    areaId: "",
    provinces: [],
    provinceId: "",
    cities: [],
    citieId: "",
    districts: [],
    districtId: "",
    villages: [],
    // branches: [],
    branchesById: [],
    branchesByAreaId: [],
    jenisAXI: [],
    religions: [],
    status: [],
    genders: [],
    legalForm: [],
    profileId: "",
    resultRevisi: "",
    thirdPartySetting: [],
    thirdPartyPageSetting: [],
    branchByPostalCode: {},
    jenisKaryawan: [],
  },
  getters: {
    getAreasSap: state => state.areas,
    getAreasSapById: state => state.areaId,
    getProvincesSap: state => state.provinces,
    getProvincesSapById: state => state.provinceId,
    getCitiesSap: state => state.cities,
    getCitiesSapById: state => state.citieId,
    getDistrictsSap: state => state.districts,
    getDistrictsSapById: state => state.districtId,
    getVillagesSap: state => state.villages,
    // getBranchesSap: state => state.branches,
    getBranchesByIdSap: state => state.branchesById,
    getBranchesByAreaIdSap: state => state.branchesByAreaId,
    getJenisAXI: state => state.jenisAXI,
    getReligions: state => state.religions,
    getStatus: state => state.status,
    getGenders: state => state.genders,
    getLegalForm: state => state.legalForm,
    getDecryptProfileId: state => state.profileId,
    getResultRevisi: state => state.resultRevisi,
    getThirdPartySetting: state => state.thirdPartySetting,
    getThirdPartyPageSetting: state => state.thirdPartyPageSetting,
    getBranchByPostalCode: state => state.branchByPostalCode,
    getJenisKaryawan: state => state.jenisKaryawan,
  },
  mutations: {
    [SET_AREAS_SAP](state, areas) {
      state.areas = areas;
    },
    [SET_AREAS_SAP_BY_ID](state, areaId) {
      state.areaId = areaId;
    },
    [SET_PROVINCES_SAP](state, provinces) {
      state.provinces = provinces;
    },
    [SET_PROVINCES_SAP_BY_ID](state, provinceId) {
      state.provinceId = provinceId;
    },
    [SET_CITIES_SAP](state, cities) {
      state.cities = cities;
    },
    [SET_CITIES_SAP_BY_ID](state, citieId) {
      state.citieId = citieId;
    },
    [SET_DISTRICTS_SAP](state, districts) {
      state.districts = districts;
    },
    [SET_DISTRICTS_SAP_BY_ID](state, districtId) {
      state.districtId = districtId;
    },
    [SET_VILLAGES_SAP](state, villages) {
      state.villages = villages;
    },
    [SET_BRANCHES_SAP](state, branches) {
      state.branches = branches;
    },
    [SET_BRANCHES_BY_ID_SAP](state, branchesById) {
      state.branchesById = branchesById;
    },
    [SET_BRANCHES_BY_AREAID_SAP](state, branchesByAreaId) {
      state.branchesByAreaId = branchesByAreaId;
    },
    [JENIS_AXI](state, jenisAXI) {
      state.jenisAXI = jenisAXI;
    },
    [SET_RELIGIONS](state, religions) {
      state.religions = religions;
    },
    [SET_STATUS](state, status) {
      state.status = status;
    },
    [SET_GENDERS](state, genders) {
      state.genders = genders;
    },
    [SET_LEGAL_FORM](state, legalForm) {
      state.legalForm = legalForm;
    },
    [SET_PROFILE_ID](state, profileId) {
      state.profileId = profileId;
    },
    [SET_RESULT_REVISI](state, resultRevisi) {
      state.resultRevisi = resultRevisi;
    },
    [SET_THIRD_PARTY_SETTING](state, thirdPartySetting) {
      state.thirdPartySetting = thirdPartySetting;
    },
    [SET_THIRD_PARTY_PAGE_SETTING](state, thirdPartyPageSetting) {
      state.thirdPartyPageSetting = thirdPartyPageSetting;
    },
    [SET_BRANCH_BY_POSTALCODE_SAP](state, payload) {
      state.branchByPostalCode = payload;
    },
    [JENIS_KARYAWAN](state, jenisKaryawan) {
      state.jenisKaryawan = jenisKaryawan;
    }
  },
  actions: {
    async updateDataRevisi({ commit }, params = {}) {
      // console.log(params);

      const result = await patchUpdateRevisi(params);
      const { data } = result;
      commit(SET_RESULT_REVISI, data);
      // console.log(data);
    },
    async fetchAreas({ commit }, params = {}) {
      const result = await getAreasSap(params);
      const { data } = result;
      commit(SET_AREAS_SAP, data);
    },
    async fetchAreasById({ commit }, payload) {
      const result = await getAreasSapById(payload);
      const { areaId } = result.data;
      commit(SET_AREAS_SAP_BY_ID, areaId);
    },
    async fetchProvinces({ commit }, params = {}) {
      const result = await getProvincesSap(params);
      const { data } = result;
      commit(SET_PROVINCES_SAP, data);
    },
    async fetchProvinceId({ commit }, params) {
      const result = await getProvincesSapById(params);
      const { provinsiId } = result.data[0];
      commit(SET_PROVINCES_SAP_BY_ID, provinsiId);
    },
    async fetchCities({ commit }, params = {}) {
      const result = await getCitiesSap(params);
      const { data } = result;
      commit(SET_CITIES_SAP, data);
    },
    async fetchCitieId({ commit }, params) {
      const result = await getCitiesSapById(params);
      const { kabupatenId } = result.data[0];
      commit(SET_CITIES_SAP_BY_ID, kabupatenId);
    },
    async fetchDistricts({ commit }, params = {}) {
      const result = await getDistrictsSap(params);
      const { data } = result;
      commit(SET_DISTRICTS_SAP, data);
    },
    async fetchDistrictId({ commit }, params) {
      const result = await getDistrictsSapById(params);
      const { kecamatanId, kodePos } = result.data[0];
      commit(SET_DISTRICTS_SAP_BY_ID, { kecamatanId, kodePos });
    },
    async fetchVillages({ commit }, params = {}) {
      const result = await getVillagesSap(params);
      const { data } = result;
      commit(SET_VILLAGES_SAP, data);
    },
    // async fetchBranches({ commit }, params = {}) {
    //   const result = await getBranchesSap(params);
    //   const { data } = result;
    //   commit(SET_BRANCHES_SAP, data);
    // },
    async fetchBranchesById({ commit }, id) {
      const result = await getBranchesByIdSap(id);
      const { data } = result;
      commit(SET_BRANCHES_BY_ID_SAP, data);
    },
    async fetchBranchesByAreaId({ commit }, id) {
      const result = await getBranchesByAreaIdSap(id);
      const { data } = result;
      commit(SET_BRANCHES_BY_AREAID_SAP, data);
    },
    async fetchJenisAXI({ commit }) {
      try {
        const result = await getJenisAXI();
        const { data } = result;
        commit(JENIS_AXI, data);
      } catch (error) {
        throw error;
      }
    },
    async fetchReligions({ commit }) {
      try {
        const result = await getReligions();
        const { data } = result;
        commit(SET_RELIGIONS, data);
      } catch (error) {
        throw error;
      }
    },
    async fetchStatus({ commit }) {
      try {
        const result = await getStatus();
        const { data } = result;
        commit(SET_STATUS, data);
      } catch (error) {
        throw error;
      }
    },
    async fetchGenders({ commit }) {
      try {
        const result = await getGenders();
        const { data } = result;
        commit(SET_GENDERS, data);
      } catch (error) {
        throw error;
      }
    },
    async fetchLegalForm({ commit }) {
      try {
        const result = await getLegalForm();
        const { data } = result;
        commit(SET_LEGAL_FORM, data);
      } catch (error) {
        throw error;
      }
    },
    async fetchDecryptProfileId({ commit }, profileId) {
      // console.log(profileId);

      try {
        const result = await getDecryptProfileId(profileId);
        const { data } = result;
        commit(SET_PROFILE_ID, data);
      } catch (error) {
        throw error;
      }
    },
    async fetchThirdPartySetting({ commit }, axiId) {
      try {
        const result = await getThirdPartySetting(axiId);
        const { data } = result;
        commit(SET_THIRD_PARTY_SETTING, data);
        return data;
      } catch (error) {
        throw error;
      }
    },
    async submitThirdPartyValue({ commit }, payload) {
      try {
        const result = await postThirdPartyValue(payload);
        const { data } = result;
        commit(SET_THIRD_PARTY_SETTING, data);
        return data;
      } catch (error) {
        throw error;
      }
    },
    // async fetchValidasiEmail({ commit }, payload) {
    //   try {
    //     const result = await getCheckEmail(payload);
    //     const { data } = result;
    //     return data.status;
    //   } catch (error) {
    //     return error.response.status;
    //   }
    // },
    async fetchValidasiEmail({ commit }, payload) {
      try {
        const result = await getCheckEmail(payload);
        const { data } = result;

        return {
          ok: true,
          status: data && data.status,
          message: (data && (data.detail || data.message)) || null,
          raw: data,
        };
      } catch (error) {
        const status = error && error.response && error.response.status;

        const errData = error && error.response && error.response.data;
        const message =
          (errData && (errData.detail || errData.message || errData.error)) ||
          (Array.isArray(errData && errData.errors) && errData.errors[0] && (errData.errors[0].message || errData.errors[0].detail)) ||
          "Terjadi kesalahan saat memvalidasi email";
        return {
          ok: false,
          status,
          message,
          raw: errData,
        };
      }
    },
    async fetchValidasiNoKtp({ commit }, payload) {
      try {
        const result = await getCheckNoKtp(payload);
        const { data } = result;
        return data.status;
      } catch (error) {
        return error.response.status;
      }
    },
    async fetchValidasiNoHp({ commit }, payload) {
      try {
        const result = await getCheckNoHp(payload);
        const { data } = result;
        return data.status;
      } catch (error) {
        return error.response.status;
      }
    },
    async fetchThirdPartyPageSetting({ commit }, payload) {
      try {
        const result = await getThirdPartyPageSetting(payload);
        const { data } = result;
        commit(SET_THIRD_PARTY_PAGE_SETTING, data);
        return data;
      } catch (error) {
        throw error;
      }
    },
    async fetchBranchByPostalCode({ commit }, payload) {
      try {
        const { data } = await getBranchByPostalCode(payload).then(res => res.data);
        commit(SET_BRANCH_BY_POSTALCODE_SAP, data);
        return data;
      } catch (error) {
        throw error;
      }
    },
    async fetchJenisKaryawan({ commit }) {
      try {
        const result = await getJenisKaryawan();
        const { data } = result;
        commit(JENIS_KARYAWAN, data);
      } catch (error) {
        throw error;
      }
    },
  }
};
